module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 133.4f17bb84.png";